import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChange,
} from '@angular/core';
import {
  PasswordCriteria,
  PasswordStrengthService,
} from 'src/app/services/password-strength/password-strength-service';

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss'],
})
export class PasswordStrengthComponent implements OnInit, OnChanges {
  @Input() public passwordToCheck: string;
  private colors = ['darkred', 'orangered', 'orange', 'yellowgreen'];
  public ruleCheckListTexts = {
    [PasswordCriteria.Length]:
      'As a minimum password must contain 8 characters!',
    [PasswordCriteria.UpperCaseLetter]: 'Include upper case letter',
    [PasswordCriteria.LowerCaseLetter]: 'Include lower case letter',
    [PasswordCriteria.Number]: 'Include a number',
    [PasswordCriteria.SpecialCharacter]: 'Include special characters',
  };

  public ruleCheckListStates = {
    [PasswordCriteria.Length]: false,
    [PasswordCriteria.UpperCaseLetter]: false,
    [PasswordCriteria.LowerCaseLetter]: false,
    [PasswordCriteria.Number]: false,
    [PasswordCriteria.SpecialCharacter]: false,
  };

  constructor(private passwordStrengthService: PasswordStrengthService) {}
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  ngOnInit(): void {}

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes.passwordToCheck.currentValue;
    this.setBarColors(4, '#DDD');
    if (password) {
      const c = this.getColor(
        this.passwordStrengthService.checkStrength(password)
      );
      this.setBarColors(c.index, c.color);
    }

    for (let key in this.ruleCheckListStates) {
      const ruleType: PasswordCriteria = PasswordCriteria[key];
      this.ruleCheckListStates[key] = this.passwordStrengthService.checkRule(
        ruleType,
        password
      );
    }
  }

  private getColor(s: number) {
    let index = 0;
    if (s === 10) {
      index = 0;
    } else if (s === 20) {
      index = 1;
    } else if (s === 30) {
      index = 2;
    } else if (s === 40) {
      index = 3;
    } else {
      index = 4;
    }
    return {
      index: index + 1,
      color: this.colors[index],
    };
  }

  private setBarColors(count, col) {
    for (let n = 0; n < count; n++) {
      this['bar' + n] = col;
    }
  }
}
